import { render, staticRenderFns } from "./AdminDataPublic.vue?vue&type=template&id=65a68fd0&"
import script from "./AdminDataPublic.vue?vue&type=script&lang=js&"
export * from "./AdminDataPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports